export function CategoryView() {
	return null;
}
